/* globals localStorage */

export default {
  /* community */
  getCm(){
    // console.log("get community:%s", localStorage.cm)
    return localStorage.cm
  },

  setCm(cb){
    if(cb.length == 0){
      console.error("setCm - input cb error:%s", cb)
      return
    }
    // console.log("set community:%s", cb)
    localStorage.cm = cb
  },

  delCm(){
    // console.log("delete community")
    delete localStorage.cm
  },
  /**/
  getCmType(){
    // console.log("get community:%s", localStorage.cm)
    return localStorage.cmType
  },

  setCmType(cb){
    if(cb.length == 0){
      console.error("setCm - input cb error:%s", cb)
      return
    }
    // console.log("set community:%s", cb)
    localStorage.cmType = cb
  },

  delCmType(){
    // console.log("delete community type")
    delete localStorage.cmType
  },

  /* openid */
  getOpenid(){
    // console.log("get openid:%s", localStorage.openid)
    return localStorage.openid
  },

  setOpenid(cb){
    if(cb.length == 0){
      console.error("setOpenid - input cb error:%s", cb)
      return
    }
    // console.log("set openid:%s", cb)
    localStorage.openid = cb
  },

  delOpenId(){
    // console.log("delete openid")
    delete localStorage.openid
  },

  /* token */
  getToken(){
    // console.log("get token:%s", localStorage.token)
    return localStorage.token
  },

  setToken(cb){
    if(cb.length == 0){
      console.error("setToken - input cb error:%s", cb)
      return
    }
    // console.log("set token:%s", cb)
    localStorage.token = cb
  },

  delToken(){
    // console.log("delete token")
    delete localStorage.token
  },

  /* name */
  getName(){
    // console.log("get name:%s", localStorage.name)
    return localStorage.name
  },

  setName(cb){
    if(cb.length == 0){
      console.error("setName - input cb error:%s", cb)
      return
    }
    // console.log("set name:%s", cb)
    localStorage.name = cb
  },

  delName(){
    // console.log("delete name")
    delete localStorage.name
  },

  /* coins */
  getCoins(){
    // console.log("get coins:%s", localStorage.coins)
    return localStorage.coins
  },

  setCoins(cb){
    if(cb.length == 0){
      console.error("setCoins - input cb error:%s", cb)
      return
    }
    // console.log("set coins:%s", cb)
    localStorage.coins = cb
  },

  delCoins(){
    // console.log("delete coins")
    delete localStorage.coins
  },

  /* portrait */
  getPortrait(){
    // console.log("get portrait:%s", localStorage.portrait)
    return localStorage.portrait
  },

  setPortrait(cb){
    if(cb.length == 0){
      console.error("setPortrait - input cb error:%s", cb)
      return
    }
    // console.log("set portrait:%s", cb)
    localStorage.portrait = cb
  },

  delPortrait(){
    // console.log("delete portrait")
    delete localStorage.portrait
  },

  /* lat */
  getLat(){
    // console.log("get lat:%s", localStorage.lat)
    return localStorage.lat
  },

  setLat(cb){
    if(cb.length == 0){
      console.error("setLat - input cb error:%s", cb)
      return
    }
    // console.log("set lat:%s", cb)
    localStorage.lat = cb
  },

  delLat(){
    // console.log("delete lat")
    delete localStorage.lat
  },

  /* longt */
  getLongt(){
    // console.log("get longt:%s", localStorage.longt)
    return localStorage.longt
  },

  setLongt(cb){
    if(cb.length == 0){
      console.error("setLongt - input cb error:%s", cb)
      return
    }
    // console.log("set longt:%s", cb)
    localStorage.longt = cb
  },

  delLongt(){
    // console.log("delete longt")
    delete localStorage.longt
  },

  /**/
  login (email, pass, cb) {
    cb = arguments[arguments.length - 1]
    if (localStorage.token) {
      if (cb) cb(true)
      this.onChange(true)
      return
    }
    pretendRequest(email, pass, (res) => {
      if (res.authenticated) {
        localStorage.token = res.token
        if (cb) cb(true)
        this.onChange(true)
      } else {
        if (cb) cb(false)
        this.onChange(false)
      }
    })
  },

  /*getToken () {
    return localStorage.token
  },*/

  logout (cb) {
    delete localStorage.token
    if (cb) cb()
    this.onChange(false)
  },

  loggedIn () {
    return !!localStorage.token
  },

  onChange () {}

}

function pretendRequest (email, pass, cb) {
  setTimeout(() => {
    if (email === 'joe@example.com' && pass === 'password1') {
      cb({
        authenticated: true,
        token: Math.random().toString(36).substring(7)
      })
    } else {
      cb({ authenticated: false })
    }
  }, 0)
}




// WEBPACK FOOTER //
// ./src/auth.js